import { useNavigate, useParams } from "react-router";
import { useWorkspaceStore } from "@/store/workspace-store";

export function useWorkspaceNavigation() {
  const navigate = useNavigate();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { activeWorkspace } = useWorkspaceStore();

  // Use workspace ID from URL params first, then fallback to active workspace
  const currentWorkspaceId = workspaceId || activeWorkspace?._id;

  const navigateToWorkspace = (path: string) => {
    if (!currentWorkspaceId) {
      // No workspace available, navigate to workspaces list
      navigate("/workspaces");
      return;
    }

    // Ensure path starts with /
    const normalizedPath = path.startsWith("/") ? path : `/${path}`;
    navigate(`/${currentWorkspaceId}${normalizedPath}`);
  };

  return {
    navigate: navigateToWorkspace,
    workspaceId: currentWorkspaceId,
    rawNavigate: navigate, // For non-workspace routes like /sign-in
  };
}